export default __webpack_public_path__ + "static/media/thumbnail.990134eb.png";